import styled from 'styled-components'
import {
  flexDirection,
  FlexDirectionProps,
  padding,
  PaddingProps,
} from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { GolfFieldImage } from 'Assets/Images/Sections/EmajinMembershipsSection'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<PaddingProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-image: url(${GolfFieldImage.src});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center bottom;

  > div,
  > button {
    z-index: 1;
  }

  ${padding}
`

export const Overflow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${themeGet('colors.overlay.deep')};
`

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps>`
  display: flex;
  justify-content: center;
  color: ${themeGet('colors.text.inverse')};
  gap: ${themeGet('space.11')}px;

  ${flexDirection}
`
